import Immutable from 'seamless-immutable'
import {REHYDRATE} from 'redux-persist/constants'
import {APP_RESET_STATE} from '../actions/app'

import * as actions from '../actions/australia-post'

const initialState = Immutable({
	ausPostDisclaimerAgreed: false
})

export default function (state = initialState, action){
	switch(action.type){
		case APP_RESET_STATE:
		case REHYDRATE:
			if(action.payload && action.payload.AustraliaPost){
				return state.set('ausPostDisclaimerAgreed', action.payload.AustraliaPost.ausPostDisclaimerAgreed)
			}
			return state

		case actions.AUSPOST_AGREE:
			return state.set('ausPostDisclaimerAgreed', true)
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/australia-post.js